import { semTracker } from './index';

semTracker.initMsg();

// export default semTracker;
